var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Inquiries",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-inquiries","viewBox":"0 0 100 100"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M69.69 33.077a1.5 1.5 0 0 1 1.81 1.5v30.878a1.5 1.5 0 0 1-1.5 1.5H30a1.5 1.5 0 0 1-1.5-1.5V34.577a1.5 1.5 0 0 1 1.5-1.5h39.69zM31.5 37.934v26.02h37V37.756l-17.207 14.39a1.5 1.5 0 0 1-1.896.024L31.5 37.934zm2.486-1.857l16.32 12.982L65.83 36.077H33.986zM50 100C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50zm0-4c25.405 0 46-20.595 46-46S75.405 4 50 4 4 24.595 4 50s20.595 46 46 46z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/inquiries.svg